import { set, unset } from 'lodash-es';

export function setOne(target, path, value) {
  set(target, path, value);
  return target;
}

export function setMany(target, pathValueMap) {
  Object.entries(pathValueMap).forEach(([path, value]) => setOne(target, path, value));
  return target;
}

export function deleteOne(target, path) {
  unset(target, path);
  return target;
}

export function deleteMany(target, paths) {
  paths.forEach((path) => deleteOne(target, path));
  return target;
}
